"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var messageText;
        (function (messageText) {
            var edit;
            (function (edit) {
                class InitArgs {
                    constructor() {
                        this.defaultInvite = appn.emptyString;
                        this.defaultForgotPassword = appn.emptyString;
                        this.defaultFile = appn.emptyString;
                        this.defaultNoticeAlert = appn.emptyString;
                    }
                }
                let _initArgs;
                edit.inviteEditor = {};
                edit.forgotPasswordEditor = {};
                edit.fileEditor = {};
                edit.noticeAlertEditor = {};
                function init(args) {
                    _initArgs = args;
                    edit.inviteEditor = appn.codeMirror.applyToTextArea('#MessageText_UserInviteHtml', appn.codeMirror.codeTypes.htmlAndScript);
                    edit.forgotPasswordEditor = appn.codeMirror.applyToTextArea('#MessageText_UserForgotPasswordHtml', appn.codeMirror.codeTypes.htmlAndScript);
                    edit.fileEditor = appn.codeMirror.applyToTextArea('#MessageText_FileEmailHtml', appn.codeMirror.codeTypes.htmlAndScript);
                    edit.noticeAlertEditor = appn.codeMirror.applyToTextArea('#MessageText_NoticesAlertHtml', appn.codeMirror.codeTypes.htmlAndScript);
                    addEvents();
                }
                edit.init = init;
                function addEvents() {
                    $('.restore-default-invite').on('click', function () {
                        edit.inviteEditor === null || edit.inviteEditor === void 0 ? void 0 : edit.inviteEditor.setValue(_initArgs.defaultInvite);
                        appn.toast.notify(appn.toast.Type.info, 'Default user invite body HTML has been restored, don\'t forget to hit save.');
                    });
                    $('.restore-default-forgot-password').on('click', function () {
                        edit.forgotPasswordEditor === null || edit.forgotPasswordEditor === void 0 ? void 0 : edit.forgotPasswordEditor.setValue(_initArgs.defaultForgotPassword);
                        appn.toast.notify(appn.toast.Type.info, 'Default user forgot password body HTML has been restored, don\'t forget to hit save.');
                    });
                    $('.restore-default-file').on('click', function () {
                        edit.fileEditor === null || edit.fileEditor === void 0 ? void 0 : edit.fileEditor.setValue(_initArgs.defaultFile);
                        appn.toast.notify(appn.toast.Type.info, 'Default file email HTML has been restored, don\'t forget to hit save.');
                    });
                    $('.restore-default-noticeAlert').on('click', function () {
                        edit.noticeAlertEditor === null || edit.noticeAlertEditor === void 0 ? void 0 : edit.noticeAlertEditor.setValue(_initArgs.defaultNoticeAlert);
                        appn.toast.notify(appn.toast.Type.info, 'Default notice alert HTML has been restored, don\'t forget to hit save.');
                    });
                }
            })(edit = messageText.edit || (messageText.edit = {}));
        })(messageText = views.messageText || (views.messageText = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
